import apiClient from "./apiClient";

// Create Driver Payout
export const createDriverPayout = async (data) => {
  const response = await apiClient.post("/driver-payouts/add", data);
  return response.data;
};

// Get All Driver Payouts
export const getAllDriverPayouts = async (params = {}) => {
  const response = await apiClient.get("/driver-payouts/getall", { params });
  return response.data;
};

// Get Driver Payout By Id
export const getDriverPayoutById = async (id) => {
  const response = await apiClient.get(`/driver-payouts/get/${id}`);
  return response.data;
};

// Update Driver Payout
export const updateDriverPayout = async (id, data) => {
  const response = await apiClient.put(`/driver-payouts/update/${id}`, data);
  return response.data;
};

// Delete Driver Payout
export const deleteDriverPayout = async (id) => {
  const response = await apiClient.delete(`/driver-payouts/delete/${id}`);
  return response.data;
};

// Get Driver Payout Payment Summary
export const getDriverPayoutPaymentSummary = async (params = {}) => {
  const response = await apiClient.get("/driver-payouts/payment-summary", { params });
  return response.data;
};

// Update Driver Payout Status
export const updateDriverPayoutStatus = async (id, status) => {
  const response = await apiClient.put(`/driver-payouts/update-status/${id}`, { status });
  return response.data;
};

const driverPayoutApi = {
  createDriverPayout,
  getAllDriverPayouts,
  getDriverPayoutById,
  updateDriverPayout,
  deleteDriverPayout,
  getDriverPayoutPaymentSummary,
  updateDriverPayoutStatus,
};

export default driverPayoutApi;